import { type EntityId } from '../entities/EntityId';

/** The two fields that decide where a sprite lands in the draw order. */
export interface SpriteDrawOrderKey {
  /** Owning entity, which breaks ties between equal sort orders. */
  readonly entityId: EntityId;
  /** Draw order; higher values draw in front. */
  readonly sortOrder: number;
}

/**
 * Orders sprites back to front: by {@link SpriteDrawOrderKey.sortOrder}, then by entity id.
 *
 * Backend-neutral on purpose. Draw order is part of the {@link Renderer} contract rather than a
 * property of any one backend, so every adapter sorts identically and a scene looks the same whatever
 * is drawing it. The entity id tie-break is what makes the result stable frame to frame instead of
 * depending on the order a hash map happened to iterate in.
 */
export function compareSpriteDrawOrder(first: SpriteDrawOrderKey, second: SpriteDrawOrderKey): number {
  if (first.sortOrder !== second.sortOrder) {
    return first.sortOrder - second.sortOrder;
  }
  return first.entityId - second.entityId;
}
